// Shared XHR helpers. Fetch is monkey-patched by the Emergent platform script
// (it eagerly reads response bodies for logging) which causes
// "body stream already read" / "Response body is already used" errors when
// our code tries to read 4xx responses. XMLHttpRequest is not affected.
export const API = process.env.REACT_APP_BACKEND_URL;

export function xhrJson(method, url, body, headers = {}, timeoutMs = 60000) {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    Object.entries(headers).forEach(([k, v]) => xhr.setRequestHeader(k, v));
    xhr.timeout = timeoutMs;
    xhr.onload = () => {
      let data = {};
      try { data = xhr.responseText ? JSON.parse(xhr.responseText) : {}; }
      catch { data = { detail: xhr.responseText }; }
      resolve({ ok: xhr.status >= 200 && xhr.status < 300, status: xhr.status, data });
    };
    xhr.onerror = () => resolve({ ok: false, status: 0, data: { detail: 'Network error' } });
    xhr.ontimeout = () => resolve({ ok: false, status: 0, data: { detail: 'Request timed out' } });
    xhr.send(body ? JSON.stringify(body) : null);
  });
}

export function authHeader(session) {
  return session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {};
}
